/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PageUpdateTrigger {
  CREATE_PAGE = "CREATE_PAGE",
  DISCARD_CHANGES = "DISCARD_CHANGES",
  EDIT_PAGE = "EDIT_PAGE",
  LINK_REFACTORING = "LINK_REFACTORING",
  MIGRATE_PAGE_COLLAB = "MIGRATE_PAGE_COLLAB",
  OWNER_CHANGE = "OWNER_CHANGE",
  PAGE_RENAME = "PAGE_RENAME",
  PERSONAL_TASKLIST = "PERSONAL_TASKLIST",
  REVERT = "REVERT",
  SPACE_CREATE = "SPACE_CREATE",
  UNKNOWN = "UNKNOWN",
  VIEW_PAGE = "VIEW_PAGE",
}

export enum TaskStatus {
  CHECKED = "CHECKED",
  UNCHECKED = "UNCHECKED",
}

export interface InlineTask {
  status: TaskStatus;
  taskId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetBatchedTaskStatus
// ====================================================


import { SetBatchedTaskStatusMutation$data, SetBatchedTaskStatusMutation$variables } from '../__generated__/SetBatchedTaskStatusMutation.graphql.ts';

export type SetBatchedTaskStatus = SetBatchedTaskStatusMutation$data;

export type SetBatchedTaskStatusVariables = SetBatchedTaskStatusMutation$variables;
